// Other context factories
import {SellerServicesFactory} from '../../seller/Services/factory.js'
// Draft Factories
import {DraftMappersFactory} from '../Mappers/factory.js'
import {DraftRepositoriesFactory} from '../Repositories/factory.js'
import {DraftValueObjectsFactory} from '../ValueObjects/factory.js'
// Draft Services
import {DiscardDraftService} from './DiscardDraftService.js'
import {EditDraftService} from './EditDraftService.js'
import {OngoingDraftService} from './OngoingDraftService.js'
import {PublishDraftService} from './PublishDraftService.js'

export class DraftServicesFactory {
  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {OngoingDraftService}
   * @property {HTTPDraftRepository} repository
   */
  static ongoingDraftService = ({config}) => {
    return new OngoingDraftService({
      cookieRepository: DraftRepositoriesFactory.cookieDraftRepository({config}),
      httpRepository: DraftRepositoriesFactory.hTTPDraftRepository({config})
    })
  }

  static discardDraftService = ({config}) => {
    return new DiscardDraftService({
      cookieRepository: DraftRepositoriesFactory.cookieDraftRepository({config}),
      httpRepository: DraftRepositoriesFactory.hTTPDraftRepository({config})
    })
  }

  static editDraftService = ({config}) => {
    return new EditDraftService({
      cookieRepository: DraftRepositoriesFactory.cookieDraftRepository({config}),
      httpRepository: DraftRepositoriesFactory.hTTPDraftRepository({config})
    })
  }

  static publishDraftService = ({config}) => {
    return new PublishDraftService({
      config,
      errorsPublishDraftVOFactory: DraftValueObjectsFactory.errorsPublishDraftValueObject,
      fromPublishDraftResponseToUrlValueObjectMapper:
        DraftMappersFactory.fromPublishDraftResponseToUrlValueObjectMapper({
          config
        }),
      getInstantOfferByAdService: SellerServicesFactory.getInstantOfferByAdSellerService({config}),
      repository: DraftRepositoriesFactory.hTTPDraftRepository({config})
    })
  }
}
